import _ from 'lodash';

import createModel, { prop } from '../lib/create_model';

export const AggregationLevel = Object.freeze({
  QUARTER_HOUR: 'quarterHourly',
  HALF_HOUR: 'halfHourly',
  DAY: 'daily',
  WEEK: 'weekly',
  MONTH: 'monthly',
  QUARTER: 'quarterly',
});

export const ReportConfig = createModel({
  modelName: 'ReportConfig',
  properties: {
    metricSetName: prop(String),
    title: prop(String),
    categoryId: prop(String),
    urlSlug: prop(String),
    filters: prop([String]).default([]),
    timeAggregation: prop([String]),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default createModel({
  modelName: 'ReportConfigs',
  properties: {
    configs: prop([ReportConfig]),
  },

  isEmpty() {
    return _.isEmpty(this.configs);
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export const LegacyConfigs = [
  {
    metricSetName: 'AgentsReport',
    title: 'Agent Performance Summary',
    categoryId: 'Sunsetting',
    urlSlug: 'agents',
    filters: ['dateRange', 'timeAggregation', 'channel', 'teams', 'inboxes'],
    timeAggregation: ['daily', 'weekly', 'monthly', 'quarterly'],
  },
  {
    metricSetName: 'TopicHierarchyReport',
    title: 'Topics',
    categoryId: 'Customer Experience',
    urlSlug: 'topics',
    filters: ['dateRange', 'timeAggregation', 'channel', 'inboxes', 'topics'],
    timeAggregation: ['daily', 'weekly', 'monthly', 'quarterly'],
  },
  {
    metricSetName: 'SummaryReport',
    title: 'Operational Summary',
    categoryId: 'Operational Performance',
    urlSlug: 'summary',
    filters: ['dateRange', 'timeAggregation', 'channel', 'inboxes'],
    timeAggregation: ['daily', 'weekly', 'monthly', 'quarterly'],
  },
  {
    metricSetName: 'IvrEndStatesReport',
    title: 'IVR',
    categoryId: 'Customer Experience',
    urlSlug: 'ivr-end-states',
    filters: ['dateRange', 'timeAggregation', 'phoneNumber'],
    timeAggregation: ['daily', 'weekly', 'monthly', 'quarterly'],
  },
  {
    metricSetName: 'IvrExecutiveSummaryReport',
    title: 'IVR',
    categoryId: 'Customer Experience',
    urlSlug: 'ivr-summary',
    filters: ['dateRange', 'timeAggregation', 'phoneNumber'],
    timeAggregation: ['daily', 'weekly', 'monthly', 'quarterly'],
  },
];

export const LegacyReportConfigs = LegacyConfigs.map(config => {
  return new ReportConfig(config);
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/reports/report_configs.js